export default __webpack_public_path__ + "static/media/upload-circle.4b9a119a.svg";